export const PrimaryProductKeys: {
	readonly Atlas: 'townsquare';
	readonly Confluence: 'confluence';
	readonly Assets: 'cmdb';
	readonly Focus: 'mercury';
	readonly Jira: 'jira';
	readonly Elevate: 'elevate';
	readonly Talent: 'radar';
	readonly RovoExtension: 'rovo-extension';
	readonly Loom: 'loom';
} = {
	// Fully supported as GA
	Atlas: 'townsquare',
	Confluence: 'confluence',
	// In development
	Assets: 'cmdb',
	Focus: 'mercury',
	Jira: 'jira',
	Elevate: 'elevate',
	Talent: 'radar',
	RovoExtension: 'rovo-extension',
	Loom: 'loom',
} as const;
